import { useState } from 'react';
import { faqs } from '@/mocks/asmrData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            关于ASMR和asmr1，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-background-100 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-background-200/50 transition-colors duration-200"
              >
                <span className="font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}